import type { LangCode } from '@learnforge/i18n';
import type { DemoKey } from '../types';
import { en } from './en';
import { ar } from './ar';
import { bn } from './bn';
import { de } from './de';
import { es } from './es';
import { fa } from './fa';
import { fr } from './fr';
import { gu } from './gu';
import { hi } from './hi';
import { id } from './id';
import { it } from './it';
import { ja } from './ja';
import { ko } from './ko';
import { mr } from './mr';
import { nl } from './nl';
import { pa } from './pa';
import { pl } from './pl';
import { pt } from './pt';
import { ro } from './ro';
import { ru } from './ru';
import { sw } from './sw';
import { ta } from './ta';
import { te } from './te';
import { th } from './th';
import { tl } from './tl';
import { tr } from './tr';
import { uk } from './uk';
import { ur } from './ur';
import { vi } from './vi';
import { zh } from './zh';

// Non-English locales are partial (keys missing fall back to English at runtime).
// The cast satisfies createI18n's type, which marks the whole language as optional
// but treats present entries as full records. The runtime handles missing keys safely.
export const locales: Partial<Record<LangCode, Record<DemoKey, string>>> & {
  en: Record<DemoKey, string>;
} = {
  en,
  ro: ro as Record<DemoKey, string>,
  zh: zh as Record<DemoKey, string>,
  hi: hi as Record<DemoKey, string>,
  es: es as Record<DemoKey, string>,
  fr: fr as Record<DemoKey, string>,
  ar: ar as Record<DemoKey, string>,
  bn: bn as Record<DemoKey, string>,
  pt: pt as Record<DemoKey, string>,
  ru: ru as Record<DemoKey, string>,
  ur: ur as Record<DemoKey, string>,
  id: id as Record<DemoKey, string>,
  de: de as Record<DemoKey, string>,
  ja: ja as Record<DemoKey, string>,
  mr: mr as Record<DemoKey, string>,
  te: te as Record<DemoKey, string>,
  tr: tr as Record<DemoKey, string>,
  ta: ta as Record<DemoKey, string>,
  vi: vi as Record<DemoKey, string>,
  tl: tl as Record<DemoKey, string>,
  ko: ko as Record<DemoKey, string>,
  fa: fa as Record<DemoKey, string>,
  sw: sw as Record<DemoKey, string>,
  it: it as Record<DemoKey, string>,
  pa: pa as Record<DemoKey, string>,
  gu: gu as Record<DemoKey, string>,
  th: th as Record<DemoKey, string>,
  pl: pl as Record<DemoKey, string>,
  uk: uk as Record<DemoKey, string>,
  nl: nl as Record<DemoKey, string>,
};
